// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateEnquiryExistingCustomerDocument = gql`
    mutation createEnquiryExistingCustomer($input: EnquiryInput!) {
  createEnquiryExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useCreateEnquiryExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateEnquiryExistingCustomerMutation, SchemaTypes.CreateEnquiryExistingCustomerMutationVariables>(CreateEnquiryExistingCustomerDocument);
};